module.exports = __webpack_public_path__ + "static/media/Conexion_Conica.286db28c.png";